import { useSelector } from "react-redux";
import { getResourceStatus } from "../redux/slices/resourceSlice";

const useResourceStatus = () => {
  const clientStatus = useSelector((state) =>
    getResourceStatus(state, "clientStatus")
  );

  const stateStatus = useSelector((state) =>
    getResourceStatus(state, "stateStatus")
  );

  const statusStatus = useSelector((state) =>
    getResourceStatus(state, "statusStatus")
  );

  const vendorStatus = useSelector((state) =>
    getResourceStatus(state, "vendorStatus")
  );

  const currencyStatus = useSelector((state) =>
    getResourceStatus(state, "currencyStatus")
  );

  const tradeCasesStatus = useSelector((state) =>
    getResourceStatus(state, "trade_casesStatus")
  );

  const vesselSystemStatus = useSelector((state) =>
    getResourceStatus(state, "vessel-systemStatus")
  );

  const vesselStatus = useSelector((state) =>
    getResourceStatus(state, "vesselStatus")
  );

  const clientEmployeeStatus = useSelector((state) =>
    getResourceStatus(state, "client-employeeStatus")
  );

  const employeeStatus = useSelector((state) =>
    getResourceStatus(state, "employeeStatus")
  );

  const addressStatus = useSelector((state) =>
    getResourceStatus(state, "addressStatus")
  );

  const bankStatus = useSelector((state) =>
    getResourceStatus(state, "bankStatus")
  );

  const searchStatus = useSelector((state) =>
    getResourceStatus(state, "searchStatus")
  );

  // From search-details

  const enquiryStatus = useSelector((state) =>
    getResourceStatus(state, "enquiriesStatus")
  );
  const quotationStatus = useSelector((state) =>
    getResourceStatus(state, "quotationsStatus")
  );

  const purchaseOrderStatus = useSelector((state) =>
    getResourceStatus(state, "purchase_ordersStatus")
  );
  const orderAcknowledgmentStatus = useSelector((state) =>
    getResourceStatus(state, "order_acknowledgmentsStatus")
  );

  const packingListsStatus = useSelector((state) =>
    getResourceStatus(state, " packing_listsStatus")
  );

  const proformaInvoicesStatus = useSelector((state) =>
    getResourceStatus(state, "proforma_invoicesStatus")
  );

  const invoicesStatus = useSelector((state) =>
    getResourceStatus(state, "invoicesStatus")
  );

  const lineItemsStatus = useSelector((state) =>
    getResourceStatus(state, "line-itemsStatus")
  );

  const searchDetailsStatus = useSelector((state) =>
    getResourceStatus(state, "search-detailsStatus")
  );

  const vendorSearchStatus = useSelector((state) =>
    getResourceStatus(state, "vendor-invoice-searchStatus")
  );

  const vendorInvoiceSearchStatus = useSelector((state) =>
    getResourceStatus(state, "vendor-invoice-searchStatus")
  );

  const clientSearchStatus = useSelector((state) =>
    getResourceStatus(state, "client-search-detailsStatus")
  );

  const tradeCaseStatus = useSelector((state) =>
    getResourceStatus(state, "trade-caseStatus")
  );

  const remarkStatus = useSelector((state) =>
    getResourceStatus(state, "remarkStatus")
  );

  const deliveryTermsStatus = useSelector((state) =>
    getResourceStatus(state, "delivery-termsStatus")
  );

  return {
    tradeCaseStatus,
    clientStatus,
    stateStatus,
    statusStatus,
    vendorStatus,
    addressStatus,
    bankStatus,
    currencyStatus,
    clientEmployeeStatus,
    employeeStatus,
    tradeCasesStatus,
    vesselStatus,
    vesselSystemStatus,
    enquiryStatus,
    quotationStatus,
    purchaseOrderStatus,
    orderAcknowledgmentStatus,
    packingListsStatus,
    proformaInvoicesStatus,
    invoicesStatus,
    lineItemsStatus,
    searchDetailsStatus,
    searchStatus,
    vendorSearchStatus,
    clientSearchStatus,
    vendorInvoiceSearchStatus,
    deliveryTermsStatus,
    remarkStatus,
  };
};

export default useResourceStatus;
